import React, { useState } from "react"
import {
  get,
  find,
  chunk,
  size,
  findIndex,
  isEqual,
  differenceWith,
} from "lodash"

import { Panel } from "./index"
import {
  ATTENTION_WORDS,
  PAGE_NUM,
  HEAT_MAP_LEVEL,
  HEAT_MAP_LEVEL_UP,
  HEAT_MAP_LEVEL_DOWN,
} from "config/const"
import { AttentionWord } from "components/atoms/text/attention"
import {
  BaseTable,
  HeatMapList,
  HeatMapSymbolList,
} from "components/molecules/table"
import { HeatMapTableList, tableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { Labels } from "components/atoms/input/input"
import { Pagination } from "components/molecules/pagination"
import { checkIsSp } from "utils/util"
import ClassNames from "classnames"
import { useLodingTrigger } from "components/actions/loading"
import store from "redux/store"
import { pageLoad } from "redux/ducks/PageLoad"

type HeatMapType = {
  data: APIResponse.Res
  onClick?: Function
  selectedData: APIResponse.Res
}

const NikkeiList: React.FC<
  HeatMapType & { data: Array<APIResponse.Res> }
> = props => {
  const [currentPage, changePage] = useState<number>(0)
  const isSP = checkIsSp()
  const list: Array<Array<APIResponse.Res>> = chunk(
    props.data,
    PAGE_NUM.PAGE_10
  )
  const currentIndex = findIndex(list[currentPage], {
    Symbol: get(props.selectedData, "Symbol"),
  })

  return (
    <>
      <BaseTable
        className="table-list-view table-striped"
        list={isSP ? tableColumns.nikkeiSp : tableColumns.nikkei}
        data={isSP ? props.data : list[currentPage]}
        onClick={props.onClick}
        active={currentIndex}
      />
      {!isSP && (
        <Pagination
          total={size(props.data)}
          list={list[currentPage]}
          current={currentPage}
          page={PAGE_NUM.PAGE_10}
          changePage={(n: number) => changePage(n)}
        />
      )}
    </>
  )
}

export const NikkeiPanel: React.FC<HeatMapType> = props => {
  const isSP = checkIsSp()
  const { loadingTrigger } = useLodingTrigger()

  const heatMapDisplayType = [
    {
      id: 0,
      name: "採用銘柄",
      component: (
        <HeatMapSymbolList
          className="table-heat-map"
          list={HeatMapTableList()}
          data={get(props.data, "ResultList", [])}
          onClick={props.onClick}
          selectedData={props.selectedData}
        />
      ),
    },
    {
      id: 1,
      name: "一覧",
      component: (
        <NikkeiList
          data={get(props.data, "ResultList", [])}
          onClick={props.onClick}
          selectedData={props.selectedData}
        />
      ),
    },
    {
      id: 2,
      name: "ヒートマップ",
      component: (
        <HeatMapList
          data={props.data}
          onClick={props.onClick}
          selectedData={props.selectedData}
        />
      ),
    },
  ]
  const [currentType, changeType] = useState<number>(
    isSP ? heatMapDisplayType[1].id : heatMapDisplayType[0].id
  )
  return (
    <Panel
      title=""
      className={ClassNames("panel-nikkei-average", {
        sp: isSP,
        "heat-map": currentType === heatMapDisplayType[2].id,
      })}
      // refresh={() => store.dispatch(pageLoad())}
      filter={
        <Labels
          className="btn-segmented-control btn-thin liquid-control filter-control-item"
          labelList={
            isSP
              ? differenceWith(
                  heatMapDisplayType,
                  [heatMapDisplayType[0]],
                  isEqual
                )
              : heatMapDisplayType
          }
          checked={currentType}
          onChange={(id: number) => {
            loadingTrigger.setLoading(true)

            changeType(id)
          }}
        />
      }
    >
      <div className="panel-table">
        {get(find(heatMapDisplayType, { id: currentType }), "component")}
      </div>
      {currentType !== 1 ? (
        <div className="message-row">
          <ul className="heat-map-level-list">
            {HEAT_MAP_LEVEL_UP.map((row, i) => (
              <li key={i} className={row.cls}>
                {row.msg}
              </li>
            ))}
          </ul>
          <ul className="heat-map-level-list">
            {HEAT_MAP_LEVEL_DOWN.map((row, i) => (
              <li key={i} className={row.cls}>
                {row.msg}
              </li>
            ))}
          </ul>
          <AttentionWord list={ATTENTION_WORDS.heatmap} />
        </div>
      ) : null}
    </Panel>
  )
}
